import { useState, useCallback } from "react";
import PaymentService from '../../services/paymentService';

const useSearchCards = () => {
    const [loading, setLoading] = useState(false);

    const searchCardsByBank = useCallback((bankId) => {
        setLoading(true);
        return PaymentService
            .GetAllCardsByBankId(bankId)
            .finally(() => setLoading(false))
    }, [])

    return {
        loading,
        searchCardsByBank
    }
}
export default useSearchCards;